import { FaYoutube } from "react-icons/fa";
export default function ExerciseExplaination({ result }) {
  return (
    <div className="relative  py-14 z-10 w-[90%]  mx-auto  text-medium-black">
      <div className="text-center mb-20 lg:mb-28">
        <h3 className="font-black text-xl lg:text-3xl mb-4">
          {result.WorkOut}
        </h3>
        <div className="flex flex-col md:flex-row gap-4 items-center justify-center mt-10 ">
          <span
            className={`px-4 lg:px-8 py-2 bg-[#94bf95] text-white font-bold rounded-2xl inline-block `}
          >
            {`Muscle : ${result.Muscles}`}
          </span>
          <span
            className={` px-6 lg:px-8 py-2 bg-[#ff6b6b] text-white font-bold rounded-2xl inline-block `}
          >
            {`Equipment : ${result.Equipment}`}
          </span>
        </div>
      </div>
      <a href={result.Video} target="_blank" rel="noopener noreferrer">
        <div className="h-[400px] bg-exercise-bg rounded-3xl flex justify-center items-center cursor-pointer bg-cover ">
          <div className=" text-6xl p-4 rounded-full h-20 w-20 bg-white flex justify-center items-center text-red-600">
            <FaYoutube />
          </div>
        </div>
      </a>
      <div className="flex flex-col gap-5 items-start mt-16">
        <span
          className={`px-4 lg:px-8 py-2 bg-light-purple text-white font-bold rounded-2xl inline-block `}
        >
          {`Intensity Level : ${result.Intensity_Level}`}
        </span>
        <h3 className="text-lg font-medium">
          {result["Intermediate Sets"]
            ? `Sets: ${result["Intermediate Sets"]}`
            : `Sets: No need`}
        </h3>
        <p className="text-lg font-normal">{`About Exercise : ${result["Long Explanation"]}`}</p>
      </div>
    </div>
    // <section className="relative mt-32 py-14 z-10 w-[90%] mx-auto">
    //   {result.WorkOut}
    //   <h2 className="font-bold text-lg text-medium-black">{result.WorkOut}</h2>
    // </section>
  );
}
